import axios from 'axios';
import Analytics from './Analytics';
import config from './config';
import siteSettingConfig from './siteSettingConfig';
import VerloopSDK from './Verloop';
import { clickStreamEventName } from 'factory/events/Constants/clickStreamEventName';

var URL = require('url-parse');
const chekIfJsonOrString = (data) => {
	var ret = true;
	try {
		JSON.parse(data);
	} catch (e) {
		ret = false;
	}
	return ret;
};
export const __localStorageSet = (key, value) => {
	let temp;
	if ((value == null) || (value == undefined)) {
		return;
	}
	if (!value || (value && typeof value == "boolean") || (value && (typeof value == 'string' || value instanceof String))) {
		temp = value;
	} else {
		temp = JSON.stringify(value);
	}
	localStorage && localStorage.setItem(key, temp);
};

export const __localStorageGet = (key) => {
	let temp = null;
	let data = null;
	if (typeof window !== 'undefined') {
		data = localStorage.getItem(key);
		if (data && typeof data == "boolean") {
			temp = data;
		} else {
			let isJSON = (data && chekIfJsonOrString(data)) || false;
			if (isJSON) {
				temp = (data && JSON.parse(data)) || null;
			} else {
				temp = data;
			}
		}
	}

	return temp;
};

export const __localStorageDel = (key) => {
	if (localStorage) {
		localStorage.removeItem(key);
	}
};

export const __razorpay_gateway_UPI = (paymentModes) => {
	let temp = false;
	paymentModes.find(item => {
		if (item.id === 3012) {
			temp = true;
		}
	});
	return temp;
};
export const __getSearchParmas = (string, ssrQuery) => {
	let result = {};
	if (typeof window !== 'undefined') {
		string = string || window.location.href;
		var url = URL(string, true);
		result = url.query;
	} else {
		result = ssrQuery || {};
	}
	return result;
};

export const __getTabTitle = () => {
	let tabTitle = '';
	let tabId = __getSearchParmas().tabId || '';
	let orderDetail = __getSearchParmas().gIdFromFront || '';
	if (orderDetail) {
		tabTitle = 'ORDER DETAIL';
	} else {
		if (tabId) {
			if (tabId == 1) {
				tabTitle = 'PROFILE';
			} else if (tabId == 4) {
				tabTitle = 'MY ADDRESSES';
			} else if (tabId == 5) {
				tabTitle = 'MY ORDERS';
			} else if (tabId == 7) {
				tabTitle = 'Gritzo Cash';
			} else if (tabId == 19) {
				tabTitle = 'MY SAVED CARD';
			}
		} else {
			tabTitle = '';
		}
	}

	return tabTitle;
};

export const __getMobileOperatingSystem = () => {
	var userAgent = navigator.userAgent || navigator.vendor || window.opera;
	// Windows Phone must come first because its UA also contains "Android"
	if (/windows phone/i.test(userAgent)) {
		return "Windows Phone";
	}
	if (/android/i.test(userAgent)) {
		return "Android";
	}
	// iOS detection from: http://stackoverflow.com/a/9039885/177710
	if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
		return "iOS";
	}
	return "unknown";
};
export const __showOpenInApp = () => {
	let temp = false;
	let isBajajPay = __isBajajPay();
	if (isBajajPay) {
		temp = false;
	} else {
		temp = true;
	}
	return temp;
};
export const __isBajajPay = () => {
	let temp = false;
	let utm_source = __getSearchParmas().utm_source;
	if (utm_source && utm_source.toLowerCase() == config.utm_source.bajajpwa || (typeof sessionStorage === 'object' && sessionStorage.getItem('utm_source') === config.utm_source.bajajpwa)) {
		temp = true;
	}
	return temp;
};
export const __getCookies = (cname) => {
	if (typeof window !== "undefined") {
		var name = cname + "=";
		var ca = document.cookie.split(";");
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i].trim();
			if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
		}
	}
	return false;
};

export const __getCookie = (cname = '') => {
	if (typeof window !== 'undefined') {
		var name = cname + "=";
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i].trim();
			if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
		}
	}
	return false;
};
export const __setCookie = (cname, cvalue, exdays, setDefaultExpiry, inHrs) => {
	if (typeof window !== 'undefined') {
		let _domain = window.location.hostname.indexOf('gritzo.com') > -1 ? window.location.hostname.match(/[^.]+\.[^.]+$/) : null;
		_domain = (_domain !== null && _domain.indexOf('qa') === -1 && _domain.indexOf('stag') === -1) ? '.' + _domain[0] : false;
		if (inHrs) {
			let expires = "expires=" + exdays.toUTCString();
			if (_domain)
				document.cookie = cname + "=" + cvalue + "; " + expires + ";domain=" + _domain + ";path=/";
			else
				document.cookie = cname + "=" + cvalue + "; " + expires + ";path=/";
		} else {
			const d = new Date();
			if (setDefaultExpiry) {
				d.setDate(exdays);
			} else {
				d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
			}
			let expires = "expires=" + d.toGMTString();
			if (_domain)
				document.cookie = cname + "=" + cvalue + "; " + expires + ";domain=" + _domain + ";path=/";
			else
				document.cookie = cname + "=" + cvalue + "; " + expires + ";path=/";
		}

	}
};
export const __deleteCookie = (name = '') => {
	if (typeof window !== 'undefined') {
		let _domain = window.location.hostname.indexOf('gritzo.com') > -1 ? window.location.hostname.match(/[^.]+\.[^.]+$/) : null;
		_domain = (_domain !== null && _domain.indexOf('qa') === -1 && _domain.indexOf('stag') === -1) ? '.' + _domain[0] : false;
		if (_domain)
			document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=" + _domain + ";path=/";
		else
			document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/";
	}
};

export const __deleteSubdomainAuthToken = () => {
	if (typeof window === 'undefined') return;

	const hostname = window.location.hostname;
	const targetHost = 'www.gritzo.com';

	// Only delete authtoken from www.gritzo.com (subdomain cookie)
	if (hostname === targetHost) {
		document.cookie = `authtoken=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;`;
	}
};
export const __showChatBot = (isChatIcon = false) => {
	let body = document.body;
	if (isChatIcon && isChatIcon == true) {
		body.classList.remove("no-chat-button");
	} else {
		body.classList.add("no-chat-button");
	}
};

export const __setLoyaltyDetail = (hkUserLoyaltyDetailsDto) => {
	const loyaltyLevelName = (hkUserLoyaltyDetailsDto && hkUserLoyaltyDetailsDto.loyaltyLevelName) || '';
	__localStorageDel("loyaltyLevelName");
	if (loyaltyLevelName) {
		__localStorageSet("loyaltyLevelName", loyaltyLevelName);
	}
};

export const __loggedIn = () => {
	const _cookie = __getCookie('assumeAuth') || __getCookie('authtoken');
	const _localValue = __getCookie('assumeId') || __localStorageGet('isUserLoggedIn');
	let userStatus = _localValue && _cookie && !__localStorageGet('isTMPUser') ? _localValue : false;
	userStatus = userStatus !== 'false' ? userStatus : false;
	return userStatus;
};


export const __removeQueryParam = (key, sourceURL) => {
	var rtn = sourceURL.split("?")[0],
		param,
		params_arr = [],
		queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
	if (queryString !== "") {
		params_arr = queryString.split("&");
		for (var i = params_arr.length - 1; i >= 0; i -= 1) {
			param = params_arr[i].split("=")[0];
			if (param === key) {
				params_arr.splice(i, 1);
			}
		}
		rtn = rtn + "?" + params_arr.join("&");
	}
	return rtn;
};
export const __appendQueryparam = (URL, key, value) => {
	URL += (URL.indexOf('?') > -1 ? '&' : '?') + `${key}=` + value;
	return URL;
};

export const __isOrderDelayed = (data) => {
	if (data && !data.estDeliveryDate) {
		return false;
	}
	const edd = new Date(data.estDeliveryDate).toDateString();
	const todaysDate = new Date().toDateString();
	const eddEpoch = new Date(data.estDeliveryDate).setHours(0, 0, 0, 0);
	const todayEpoch = new Date().setHours(0, 0, 0, 0);

	if (edd === todaysDate) {
		const currentHour = new Date().getHours();
		if (currentHour >= 21) {
			return true;
		}
	} else if (todayEpoch > eddEpoch) {
		return true;
	}
	return false;
};

export const __dataLayer = (args, pageType) => {
	let _datalayer = {
		'uH': 'guest',
		'uM': 'n.a.',
		'uG': 'n.a.',
		'oC': 'n.a.',
		'contact': 'n.a.',
		'firstName': 'n.a.',
		'birthDt': 'n.a.',
		'pageType': pageType || window.pageType,
		'pageUrl': window.location.href,
		'primaryCategory': '',
		'secondaryCategory': '',
		'tertiaryCategory': '',
		'allCats': [],
		'allNavKeys': [],
		'brand': '',
		'variantId': '',
		'productId': '',
		'cohort': '',
		'variantOfferPrice': '',
		'variantMrp': '',
		'variantDiscount': '',
		'variantName': '',
		'variantImageM': '',
		'variantImageS': '',
		'primaryMenu': '',
		'secondaryMenu': '',
		'tertiaryMenu': '',
		'navKey': '',
		'parentNavKey': '',
		'oos': '',
		'env': 'prod',
		'signup': '',
		'login': '',
		'guest': '',
		'canonicalUrl': 'https://www.gritzo.com',
		'errorCode': '',
		'browserCompat': 'true',
		'svTags': [],
		'cTags': [],
		'bTags': [],
		'isMobile': __isMobile(),
		'vendorName': '',
		'appliedOffer': '',
		'abTestMode': '',
		'ShoppingCartItemsWebEngage': [],
		'packDetails': {},
		'primaryAttributeName': "",
		'primaryAttributeValue': "",
		'secondaryAttributeName': "",
		'secondaryAttributeValue': "",
		'orderSuccessDetailsWebengage': {
			'transactionId': '',
			'totalValue': 0.0,
			'paymentMode': '',
			'shippingPrice': 0.0,
			'leafNode': "",
			'products': [
			],
			'brand': "",
			'category': "",
			'name': "",
			'variantId': "",
			'packId': ""
		},
		'newSession': true,
		'lpBrand': '',
		'lpPrimCat': '',
		'lpPrimMenu': '',
		'google_tag_parma_new': {
			'ecomm_prodid': '',
			'ecomm_pagetype': pageType || window.pageType,
			'ecomm_totalvalue': ''
		}
	};
	let _userData = __localStorageGet('userData');
	let _localValue = __localStorageGet('_datalayer') || [];
	let __datalayer = { ..._datalayer, ..._localValue, ...args, ..._userData };

	if (__datalayer.event !== undefined && args.event === undefined)
		delete __datalayer.event;
	__localStorageSet('_datalayer', JSON.stringify(__datalayer));
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(__datalayer);
};



export const __removeSiteStorage = () => {
	__deleteCookie("ucomm");
	__deleteCookie('authtoken');
	__deleteCookie('isAssume');
	__deleteCookie('origId');
	__deleteCookie('assumeAuth');
	__deleteCookie('assumeId');
	__deleteCookie('isRetailAssumed');
	__deleteCookie('isUserLoggedIn');
	__deleteCookie('isTMPUser');
	__deleteCookie('userType');
	__localStorageDel("loyaltyLevelName");
	__localStorageDel('isUserLoggedIn');
	__localStorageDel('_isUserLoggedIn');
	__localStorageDel('userData');
	__localStorageDel('oelp_data');
	__localStorageDel('isTMPUser');
	__localStorageDel('activeAddressId');
	__sessionStorageDel('isReturning');
	__sessionStorageDel('isUserEvent');
};

export const __updateGaEventNme = (eventName, data) => {
	let eventData = {};
	if (eventName) {
		eventData.event = eventName;
	}
	if (data) {
		eventData = { ...eventData, ...data };
	}
	if (typeof window !== "undefined") {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push(eventData);
	}
};

export const __triggerLogoutEvent = () => {
	VerloopSDK.logout();
	__removeSiteStorage();
	Analytics.Scope().logout();
	let dataLayerobj = {
		'uH': 'guest',
		'uM': 'n.a.',
		'uG': 'n.a.',
		'oC': 'n.a.',
		'contact': 'n.a.',
		'firstName': 'n.a.',
		'birthDt': 'n.a.',
	};
	__dataLayer(dataLayerobj, window.pageType);
	__updateGaEventNme('reactLogout');
	let loggedInRequiredPages = [
		"cart", "selectAddress", "selectPayment", "paymentSuccess", config.pageTypes.mbDataCapture, config.pageTypes.gritzo.growthTrack
	];
	if (loggedInRequiredPages.indexOf(window.pageType) > -1) {
		// this.props.history.push("/");
		window.location.href = "/";
	} else {
		window.location.reload();
	}
};

export const __chatActiveHours = () => {
	let flag = false;
	let hour = new Date().getHours();
	if (hour > 9 && hour < 19) {
		flag = true;
	}
	return flag;
};

export const __chatSupportPopup = (bool, data) => {
	const event = new CustomEvent("chatBotPopup", { detail: { isTriggered: bool, orderData: data } });
	window.dispatchEvent(event);
};

export const __chatFallbackHandler = (bool) => {
	const event = new CustomEvent("chatFallback", { detail: { isTriggered: bool } });
	window.dispatchEvent(event);
	if (bool === false) {
		__chatSupportPopup(false);
	}
};
export const __chatBotData = (chatBotData) => {
	const keys = ['title', 'message', 'support', 'subTitle', 'subTitle', 'team', 'email'];
	let obj = {
		"title": '',
		"message": '',
		"support": '',
		"subTitle": '',
		"team": '',
		"email": '',
	};

	if (chatBotData && chatBotData.length > 0) {
		chatBotData.forEach((item) => {
			const key = item.name;
			if (key && keys.indexOf(key) > -1) {
				obj[key] = item.value;
			}
		});
	}
	return obj;
};
export const __commaSeparator = (num) => {
	var x = num;
	x = x.toString();
	var lastThree = x.substring(x.length - 3);
	var otherNumbers = x.substring(0, x.length - 3);
	if (otherNumbers != '')
		lastThree = ',' + lastThree;
	var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
	return res;
};

export const __isMobile = (props) => {
	let check = false;
	if (typeof window === 'undefined') {
		check = props && props.isMobile ? true : false;
	} else {
		(function (a) {
			if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(a))
				check = true;
		})(navigator.userAgent || navigator.vendor || window.opera);
	}
	return check;
};

export const __getImage = (path) => {
	let _cdns = process.env.NEXT_PUBLIC_CDN_URLS.split(',');
	return _cdns[0] + '/static/media' + path;
};
export const __isCallBackExist = (method) => {
	let temp = false;
	if (method && typeof method === 'function') {
		temp = true;
	}
	return temp;
};
export const __createOfferData = (offers) => {
	let tempOffers = [];
	offers && offers.length > 0 && offers.map(eachOffers => {
		if (eachOffers.issuerOfferMapping &&
			eachOffers.issuerOfferMapping.name &&
			eachOffers.issuerOfferAdditionalCriteriaDTO &&
			eachOffers.issuerOfferAdditionalCriteriaDTO.acquisitionChannelSources &&
			eachOffers.issuerOfferAdditionalCriteriaDTO.acquisitionChannelSources.length > 0)
			eachOffers.issuerOfferAdditionalCriteriaDTO.acquisitionChannelSources.map(source => {
				source = (source || '').toLowerCase();
				let affeliate = (__getCookie("affiliateName") || '').toLowerCase();
				if (source === affeliate) {
					tempOffers.push({
						do: eachOffers.do,
						id: eachOffers.id,
						off_nm: eachOffers.nm,
						offerImageLink: eachOffers.bankImageUrl,
						offerString: eachOffers.offerDesc,
						payMode: eachOffers.issuerOfferMapping.name,
						termAndCondtion: eachOffers.issuerOfferAdditionalCriteriaDTO.termAndCondtion,
						specialOffer: true,
						issuerCode: eachOffers.issuerOfferMapping.issuerCode,
						isAdditionalOffer: true,
						discount: eachOffers.discount,
					});
				}
			});
	});
	return tempOffers;
};
export const __dateBefore = (d, days) => {
	let temp = new Date(d);
	temp = new Date(temp.setDate(temp.getDate() + days));
	return temp;
};

export const __dateAfter = (d, days) => {
	let temp = new Date(d);
	temp = new Date(temp.setDate(temp.getDate() + days));
	return temp;
};

export const __isEmptyObj = (obj) => {
	try {
		return Object.keys(obj).length === 0;
	} catch (err) {
		console.log(err);
	}
};

export const __getDate = (str) => {

	let date = str && str.length > 0 && str.split('-');
	const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
		"Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
	];
	let monthIndex = date && date.length > 0 && date[1] && date[1] - 1;
	let newDate = `${date && date[0]}  ${monthNames && monthNames[Number(monthIndex)]}  ${date && date[2]} `;
	return newDate;
};

export const __getLoyaltyIconrender = (pageType) => {
	return (pageType !== 'selectPayment' && pageType !== 'checkout' && pageType !== 'cart' && pageType !== 'Track Order' && pageType !== 'MyAccount');
};

export const __isMemberShipProduct = (reviewData) => {
	let temp = false;

	if (reviewData && (reviewData.catName || '').toLowerCase() == 'consult services') {
		temp = true;
	}
	return temp;
};

export const _sameDayDeliveryString = (messageTat) => {
	let sameDayDeliveryString = '';
	if (messageTat) {
		if ((messageTat || '').includes('tomorrow') || (messageTat || '').includes('next day')) {
			sameDayDeliveryString = "Tomorrow";
		} else if ((messageTat || '').includes('today') || (messageTat || '').includes('within') || (messageTat || '').includes('before') || (messageTat || '').includes('hrs') || (messageTat || '').includes('hr')) {
			sameDayDeliveryString = "Today";
		}
	}
	return sameDayDeliveryString;
};

export const __setDataLayer = (data) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(data);
};
export const __dataLayerAdded = (obj = {}) => {
	if (!window.dataLayer) window.dataLayer = [];
	window.dataLayer.push(obj);
};
export const __sessionStorageSet = (key, value) => {
	let temp;
	if (value == null || value == undefined) {
		return;
	}
	if (!value || (value && typeof value == "boolean") || (value && (typeof value == 'string' || value instanceof String))) {
		temp = value;
	} else {
		temp = JSON.stringify(value);
	}
	sessionStorage && typeof sessionStorage === 'object' && sessionStorage.setItem(key, temp);
};

export const __sessionStorageGet = (key = '') => {
	let temp = null;
	let data = null;
	if (sessionStorage) {
		data = sessionStorage.getItem(key);
		if (data && typeof data == "boolean") {
			temp = data;
		} else {
			let isJSON = (data && chekIfJsonOrString(data)) || false;
			if (isJSON) {
				temp = (data && JSON.parse(data)) || null;
			} else {
				temp = data;
			}
		}
	}
	return temp;
};
export const __sessionStorageDel = (key = '') => {
	if (sessionStorage) {
		sessionStorage.removeItem(key);
	}
};

export const __isValidPinCode = (pin) => {
	const regex = /^[1-9]{1}[0-9]{2}\s?[0-9]{3}$/;
	return regex.test(pin);
};

export const __loader = (isShow) => {
	let x = document.getElementById("tb-loader") || document.getElementById('mb-loader');
	if (x) {
		if (isShow) {
			x.classList.add("show");
		} else {
			x.classList.remove("show");
		}
	}
};

export const __itracker = (w, p, c, e) => {
	var _itracker = "itracker=";
	if (w) {
		w = typeof w === "string" ? w : w.join("|");
		_itracker += "w:" + encodeURIComponent(w).replace(/%7C/g, "|") + "|;";
	}
	if (p) _itracker += "p:" + encodeURIComponent(p) + "|;";
	if (c) _itracker += "c:" + encodeURIComponent(c) + "|;";
	if (e) _itracker += "e:" + encodeURIComponent(e) + "|;";
	return _itracker.replace(/--/g, "");
};

export const __urlMaker = (fragment, navkey, itracker) => {
	itracker = itracker || false;
	let _start = "";
	if (navkey) {
		if (navkey.indexOf("BR-") > -1) {
			_start = "";
		} else if (navkey.indexOf("VRNT-") > -1) {
			_start = "/sv";
		} else if (navkey.indexOf("PA-") > -1) {
			_start = "/pk";
		}
	}
	let _url = _start + fragment;
	if (navkey && _url.indexOf("navKey") === -1) {
		_url = _start + fragment + (navkey ? "?navKey=" + navkey : "");
	}
	_url += itracker ? "&" + __itracker(...itracker) : "";
	_url = _url.replace(process.env.NEXT_PUBLIC_ACTUAL_PUBLIC_URL, "");
	_url = _url.replace(siteSettingConfig.WEBSITE_URL, "");
	return _url;
};

export const __triggerErrorEvent = (eventData) => {
	const isEmptyData = __isEmptyObj(eventData);
	if (!isEmptyData) {
		Analytics.Scope().triggerClickStreamEvent(
			clickStreamEventName.ERROR,
			eventData
		);
	}

};

export const __stopScroll = (isTrue) => {
	if (isTrue) {
		//stops scroll
		document.getElementById("mainBodyId").style.overflow = "hidden";
	} else {
		//enables scroll
		document.getElementById("mainBodyId").style.overflow = "";
	}
};

export const __getCartDisplayName = (data) => {
	if (data.nm) return data.nm;
	return data.sv_nm;
};

export const __getIntOrEmpty = (val) => {
	let result = "";
	try {
		let number = parseInt(val);
		result = Number.isInteger(number) ? number : "";
	} catch (err) {
		console.log(err);
	}
	return result;
};

export const __getVitalsCash = () => {
	if (__loggedIn()) {
		const userData = __localStorageGet("userData");
		if (userData) {
			return userData.hkCash;
		} else {
			return 0;
		}
	} else {
		return 0;
	}
};

export const __HKVToast = (
	msg,
	timeout = 10000,
	className,
	isInsertImage = false
) => {
	let x = document.getElementById("HKV_TOAST");
	if (x) {
		let img;
		if (isInsertImage) {
			img = document.createElement("img");
			img.src = __getImage("/cartNew/addToCartToast.svg");
			img.style.marginRight = "10px";
		}
		x.innerHTML = `<span>${msg}</span>`;
		if (isInsertImage) x.appendChild(img);
		x.className = className ? className : "show";
		setTimeout(function () {
			x.className = x.className.replace("show", "");
			if (className) {
				x.className = x.className.replace(className, "");
			}
		}, timeout);
	}
};


export const appendHeaders = (args, URL) => {
	let tempHeaders = { ...args.header };
	let isV3 = false;
	let userID;
	let authToken;
	let pincode = __getCookies("hkPincode");
	if (pincode !== "undefined" && !args.newUrl) {
		tempHeaders["pincode"] = pincode;
	}
	if (!args.newUrl || URL.indexOf("/v1/") > -1) {
		tempHeaders = {
			st: config.storeId,
			plt: __isMobile() ? 2 : 1,
			device: __localStorageGet("deviceId"),
			...tempHeaders
		};
	}

	if (args.header !== undefined && args.header.userId !== undefined) {
		userID = args.header.userId;
		authToken = args.header.authToken;
		isV3 = true;
	} else {
		let _tmpUser = __localStorageGet("isTMPUser");
		userID =
			__loggedIn() || (_tmpUser ? __localStorageGet("isUserLoggedIn") : false);
		authToken = __getCookies("assumeAuth") || __getCookies("authtoken");
		isV3 = (userID && authToken) || (userID && authToken && _tmpUser);
	}
	if (isV3 && !args.newUrl) {
		tempHeaders = {
			...{
				HKAUTH: userID + "|" + authToken,
				"Content-Type": "application/json",
			}, ...tempHeaders
		};
		if (__getCookies("isRetailAssumed") === "true") {
			tempHeaders = {
				...{
					ASSUMEAUTH: __getCookies("origId") + "|" + __getCookies("authtoken"),
				}, ...tempHeaders
			};
		}
	}
	if (
		(URL.indexOf("/payment") > -1 ||
			URL.indexOf("/sv") > -1 ||
			URL.indexOf("/pk") > -1) &&
		(URL.indexOf("/v3/freeCheckout") > -1 ||
			URL.indexOf("/v3/loyalty") > -1 ||
			URL.indexOf("/nativePayment") > -1 ||
			URL.indexOf("/v3/accept") > -1 ||
			URL.indexOf("/v3/create") ||
			URL.indexOf("/accept/native/updatePaymentMode") > -1 ||
			URL.indexOf("/accept/native") > -1 ||
			URL.indexOf("/accept/native/tokenize") > -1 ||
			URL.indexOf("/accept/native/new") > -1 ||
			URL.indexOf("/accept/native") > -1 ||
			URL.indexOf("/prepareV2") > -1 ||
			URL.indexOf("/cardOfferForCard") > -1 ||
			URL.indexOf("/issuerOfferWithAdditionalCriteria") > -1)
	) {
		let utmSource = __getCookies("affiliateName");
		let utmMedium = __getCookies("affiliateMedium");
		let utmCampaign = __getCookies("affiliateCampaign");
		if (utmSource) {
			tempHeaders["utm_source"] = utmSource || "";
		}
		if (utmMedium) {
			tempHeaders["utm_medium"] = utmMedium || "";
		}
		if (utmCampaign) {
			tempHeaders["utm_campaign"] = utmCampaign || "";
		}
	}
	return tempHeaders;
};

export const __createDataLayer = (args, pageType) => {
	const _userData = __localStorageGet('userData') || {};
	let _datalayer = {
		uH: "guest",
		uM: "n.a.",
		uG: "n.a.",
		oC: "n.a.",
		contact: "n.a.",
		firstName: "n.a.",
		birthDt: "n.a.",
		pageType: pageType || window?.pageType,
		pageUrl: window?.location?.href,
		primaryCategory: "",
		secondaryCategory: "",
		tertiaryCategory: "",
		allCats: [],
		allNavKeys: [],
		brand: "",
		variantId: "",
		productId: "",
		cohort: "",
		variantOfferPrice: "",
		variantMrp: "",
		variantDiscount: "",
		variantName: "",
		variantImageM: "",
		variantImageS: "",
		primaryMenu: "",
		secondaryMenu: "",
		tertiaryMenu: "",
		navKey: "",
		parentNavKey: "",
		oos: "",
		env: "prod",
		signup: "",
		login: "",
		guest: "",
		canonicalUrl: `https://gritzo.com`,
		errorCode: "",
		browserCompat: "true",
		svTags: [],
		cTags: [],
		bTags: [],
		isMobile: __isMobile(),
		vendorName: "",
		appliedOffer: "",
		abTestMode: "",
		ShoppingCartItemsWebEngage: [],
		packDetails: {},
		primaryAttributeName: "",
		primaryAttributeValue: "",
		secondaryAttributeName: "",
		secondaryAttributeValue: "",
		orderSuccessDetailsWebengage: {
			transactionId: "",
			totalValue: 0.0,
			paymentMode: "",
			shippingPrice: 0.0,
			leafNode: "",
			products: [],
			brand: "",
			category: "",
			name: "",
			variantId: "",
			packId: "",
		},
		newSession: true,
		lpBrand: "",
		lpPrimCat: "",
		lpPrimMenu: "",
		'hkUserData': {
			..._userData,
			useragent: navigator.userAgent || navigator.vendor || window.opera
		}
	};
	let _localValue = __localStorageGet("_datalayer") || [];
	let __datalayer = { ..._datalayer, ..._localValue, ...args, ..._userData };
	if (__datalayer.event !== undefined && args?.event === undefined)
		delete __datalayer.event;
	__localStorageSet("_datalayer", __datalayer);
	window?.dataLayer?.push(__datalayer);
};


export const __postAjax = () => {
	VerloopSDK.logout();
	__deleteCookie("authtoken");
	__deleteCookie("ucomm1");
	__deleteCookie("isAssume");
	__deleteCookie("origId");
	__deleteCookie("assumeAuth");
	__deleteCookie("assumeId");
	__deleteCookie("isRetailAssumed");
	__deleteCookie("isStoreManager");
	__deleteCookie("isUserLoggedIn");
	__deleteCookie("_isUserLoggedIn");
	__deleteCookie("isTMPUser");
	__deleteCookie("userType");
	__localStorageDel("isUserLoggedIn");
	__localStorageDel("_isUserLoggedIn");
	__localStorageDel("userData");
	__localStorageDel("isTMPUser");
	__localStorageDel("geoUserId");
	__localStorageDel("loyaltyLevelName");
	Analytics.Scope().logout();
	__localStorageDel("profileCompleted");
	__sessionStorageDel("previousSearch");
	__sessionStorageDel('isReturning');
	__sessionStorageDel('isUserEvent');
	let dataLayerobj = {
		uH: "guest",
		uM: "n.a.",
		uG: "n.a.",
		oC: "n.a.",
		contact: "n.a.",
		firstName: "n.a.",
		birthDt: "n.a.",
	};
	__createDataLayer(dataLayerobj, window.pageType);
};

export const __ajaxCall = (args) => {
	var timeout = 120000;
	var data = args.data || {};
	let method = args.method.toLowerCase();
	let URL;
	if (args.newUrl) {
		URL = args.newUrl;
	} else {
		URL = config.baseURL + args.url;
		if (method === "get") {
			URL +=
				(URL.indexOf("?") > -1 ? "&" : "?") + "plt=" + (__isMobile() ? 2 : 1);
			URL += (URL.indexOf("?") > -1 ? "&" : "?") + "st=" + config.storeId;
		}
	}

	var header = { ...args.header };
	let additiionalHeaders = appendHeaders(args, URL);
	header = {
		...additiionalHeaders,
	};
	const pageURI = window && window.location.pathname;
	if (pageURI) {
		header = { ...header, pageuri: pageURI };
	}
	if (method === "post") {
		data.storeId = config.storeId;
		data.platformId = __isMobile() ? 2 : 1;
	}
	URL = URL.replace(/#/g, "%23");

	if (method === "get") {
		return axios
			.get(
				URL,
				{ headers: header },
				{ withCredentials: true },
				{ timeout: timeout }
			)
			.then((res) => {
				return new Promise((resolve /* reject */) => {
					resolve(res);
				});
			})
			.catch((err) => {
				const status = err && err.response && err.response.status;
				if (status === 401 && URL.includes('/v3/')) {
					// todo logout
					__postAjax();
				}
			});
	}
	if (method === "post") {
		return axios
			.post(
				URL,
				data,
				{ headers: header },
				{ withCredentials: true },
				{ timeout: timeout }
			)
			.then((res) => {
				return new Promise((resolve /* reject */) => {
					resolve(res);
				});
			})
			.catch((err) => {
				const status = err && err.response && err.response.status;
				if (status === 401 && URL.includes('/v3/')) {
					// todo logout
					__postAjax();
				}
			});
	}
};

export const _logError = (msg) => {
	let logglyInstance = window._LTracker;
	let _userId = __loggedIn();
	if (typeof logglyInstance !== "undefined")
		logglyInstance.push({
			req: window.location.href,
			error: msg,
			time: new Date(),
			userId: _userId,
		});
};

export const __HKVErrorPopUp = (msg, arg, home, isGoBack) => {
	let _errorDOM = document.getElementById("hk--error-popup");
	if (_errorDOM != null) {
		if (typeof arg === "object" && typeof arg.title !== "undefined")
			_errorDOM.querySelector(".hk--error-popup-title span").innerText =
				arg.title;
		else if (typeof arg === "string") _logError(arg);

		if (isGoBack) {
			const element = _errorDOM.querySelector(".hk--error-popup-body-action");
			if (element) {
				_errorDOM.querySelector(".hk--error-popup-body-action").style.display =
					"block";
				_errorDOM.querySelector(".hk--error-popup-body-action").onclick =
					function () {
						window.history.back();
						_errorDOM.style.display = "none";
					};
			} else {
				setTimeout(() => {
					window.history.back();
					if (_errorDOM) {
						_errorDOM.style.display = "none";
					}
				}, 2000);
			}
		}
		_errorDOM.querySelector(".hk--error-popup-body").innerText = msg;
		_errorDOM.style.display = "block";

		_errorDOM.querySelector(".hk--error-popup-title img").onclick =
			function () {
				_errorDOM.style.display = "none";
				if (home === true) {
					window.location.href = "/";
				}
				if (isGoBack) {
					window.history.back();
				}
			};
	}
	if (
		msg &&
		(msg.indexOf("Something went") > -1 ||
			msg.indexOf("Could not process") > -1 ||
			msg.indexOf("UNAUTHORIZED ACCESS : ADDRESS_ID") > -1 ||
			msg.indexOf("Invalid Cart") > -1 ||
			msg.indexOf("Your Order Amount has been changed") > -1)
	) {
		Analytics.Scope().errorReport(msg);
	}
	if (typeof arg === "object") {
		if (arg.autoClose) {
			setTimeout(() => {
				_errorDOM.style.display = "none";
				if (arg.returnUrl) {
					window.location.href = arg.returnUrl || "/cart/Cart.action";
				}
			}, 3000);
		} else if (arg.preventAutoClose) {
			return;
		}
	}
	setTimeout(() => {
		if (typeof arg === "object" && arg.preventAutoClose) {
			return;
		} else {
			if (_errorDOM) {
				_errorDOM.style.display = "none";
			}
		}
	}, 3000);
};

export const __getPluralText = (length, singularText, pluralText) => {
	return length > 1 ? pluralText : singularText;
};

export const __triggerComponentClickEvent = (eventData) => {
	const isEmptyData = __isEmptyObj(eventData);
	if (!isEmptyData) {
		Analytics.Scope().triggerClickStreamEvent(
			clickStreamEventName.COMPONENT_CLICK,
			eventData
		);

	}

};

export const __updateDataLayer = (Dataobj) => {
	let _dataLayerObj = Dataobj;
	if (window.__RI !== undefined)
		_dataLayerObj = { ..._dataLayerObj, ...{ event: "reactPageView" } };

	window.__RI = new Date();
	__createDataLayer(_dataLayerObj, window.pageType);
};




export const __textCapitalise = (str) => {
	try {
		if (!str || str.length === 0) return str;
		return str
			.toLowerCase()
			.split(/\s/)
			.map((fragment) => fragment.charAt(0).toUpperCase() + fragment.substr(1))
			.join(" ");
	} catch (err) {
		console.log(err);
	}
	return str;
};


export const __triggerComponentViewEvent = (eventData) => {
	const isEmptyData = __isEmptyObj(eventData);
	if (!isEmptyData) {
		Analytics.Scope().triggerClickStreamEvent(
			clickStreamEventName.COMPONENT_VIEW,
			eventData
		);
	}

};

export const __titleCase = (text) => {
	if (text) {
		let transformText = text.toString().toLowerCase().split("");
		transformText[0] = transformText[0].toUpperCase();
		transformText = transformText.join("");
		return transformText;
	} else return text;
};

export const __updateScreenName = () => {
	if (__localStorageGet("prevScreenName") === null) {
		localStorage.setItem("currScreenName", window.pageType);
		localStorage.setItem("prevScreenName", window.pageType);
	}
	if (window.pageType !== __localStorageGet("currScreenName")) {
		let prevPage = __localStorageGet("currScreenName");
		localStorage.setItem("prevScreenName", prevPage);
		localStorage.setItem("currScreenName", window.pageType);
	} else {
		localStorage.setItem("prevScreenName", window.pageType);
		localStorage.setItem("currScreenName", window.pageType);
	}
};

export const __noFollowNoIndex = () => {
	let robotsTag = document.querySelector('meta[name="robots"]');
	if (!robotsTag) {
		robotsTag = document.createElement("meta");
	}
	robotsTag.setAttribute("name", "robots");
	robotsTag.setAttribute("content", "noindex,nofollow");
	document.head.appendChild(robotsTag);

	let googlebot = document.querySelector('meta[name="googlebot"]');
	if (!googlebot) {
		googlebot = document.createElement("meta");
	}
	googlebot.setAttribute("name", "googlebot");
	googlebot.setAttribute("content", "noindex,nofollow");
	document.head.appendChild(googlebot);

	let canonicalLink = document.querySelector('link[rel="canonical"]');
	if (canonicalLink) {
		canonicalLink.setAttribute('href', '');
	}
	let ampLink = document.querySelector('link[rel="amphtml"]');
	if (ampLink) {
		ampLink.remove();
	}
};
export const __noFollowNoIndexRemove = (str) => {
	if (typeof window !== "undefined") {
		const url = str || window.location.href;
		const isNoFollowNoIndex = __isNoFollowNoIndex(url);
		if (!isNoFollowNoIndex) {
			let robotsTag = document.querySelector('meta[name="robots"]');
			let googlebot = document.querySelector('meta[name="googlebot"]');
			robotsTag && robotsTag.remove();
			googlebot && googlebot.remove();
		}
	}
};

const __isNoFollowNoIndex = (__url) => {
	let temp = false;
	if (__url.indexOf('~') > -1) {
		temp = true;
	} else {
		const IS_PRODUCTION_ONLY = process.env.NEXT_PUBLIC_IS_PRODUCTION_ONLY && process.env.NEXT_PUBLIC_IS_PRODUCTION_ONLY.toString().toLowerCase() === "true" ? true : false;
		if (!IS_PRODUCTION_ONLY) {
			temp = true;
		}
	}
	return temp;
};

export const __checkForCartNudge = (_cartOrderSummaryReducer) => {
	let temp = false;
	if (_cartOrderSummaryReducer) {
		const totShip = _cartOrderSummaryReducer.totShip || 0;
		const totPay = _cartOrderSummaryReducer.totPay || 0;
		const freeShippingAfter = _cartOrderSummaryReducer.freeShippingAfter || 0;
		const isExpressCheckout = __getSearchParmas().expressCheckout;
		const isCartPage =
			window.pageType == "cart" ||
			window.location.href.indexOf("/cart/Cart.action") > -1 ||
			false;
		if (
			!isExpressCheckout &&
			isCartPage &&
			totShip > 0 &&
			totPay - totShip < freeShippingAfter
		) {
			temp = true;
		}
	}
	return temp;
};

export const __isArray = (obj) => {
	return obj !== undefined && obj !== null && obj.constructor == Array;
};

export const __getOrderLevelReward = (_cartOrderSummaryReducer = {}) => {
	let temp = 0;
	const { totLC, hkCashOld } = _cartOrderSummaryReducer;
	temp = (totLC > 0 ? totLC : 0) || (hkCashOld > 0 ? hkCashOld : 0);
	return temp;
};

// basic form validation
export const formValidate = {
	phoneNumber: function (str) {
		let string = str.toString();
		if (string.length === 0) {
			return false;
		}
		if (string.length !== 10) {
			return false;
		} else if (!config.const.PHONE_NO_REGEX.test(string)) {
			return false;
		}
		return true;
	},

	alphabet: function (str) {
		let string = str ? str.trim().toString() : "";
		if (string.length === 0) {
			return false;
		}
		if (string.length === 0) {
			return false;
		}
		if (!config.const.NAME_REGEX.test(string)) {
			return false;
		}
		return true;
	},

	numeric: function (str) {
		let string = str ? str.trim().toString() : "";
		if (string.length === 0) {
			return false;
		}
		if (string.length === 0) {
			return false;
		}
		if (!config.const.NUMERIC_REGEX.test(parseInt(string))) {
			return false;
		}
		return true;
	},

	email: function (str) {
		let string = str.toString();
		if (string.length === 0) {
			return false;
		}
		if (string.length === 0) {
			return false;
		}
		if (!config.const.EMAIL_REGEX.test(string)) {
			return false;
		}
		return true;
	},

	password: function (str) {
		let string = str.toString();
		if (string.length === 0) {
			return false;
		}
		if (!string.replace(/\s/g, "").length) {
			return false;
		}
		return true;
	},

	otp: function (otp, length = 6) {
		let string = otp.toString();
		return string.length === length;
	},

	address: function (address) {
		return /[^a-zA-Z0-9 //,\r\n\(\)\-\+\.\'\,\&\#]/.test(address); //returns false if not alpha/numeric
	},

	cvv: function (cvv) {
		if (!config.const.CVV_REGEX.test(cvv)) {
			return false;
		}
		return true;
	},

	pincode: function (str) {
		let string = str.toString();
		if (string.length === 0) {
			return false;
		}
		if (string.length !== 6) {
			return false;
		} else if (!config.const.NUMERIC_REGEX.test(string)) {
			return false;
		}
		return true;
	},
};


export const __noScroll = (flag) => {
	if (typeof document === "undefined") return;
	const body = document.body;
	const html = document.documentElement;

	if (flag) {
		body.classList.add("no-scrolling");
		html.classList.add("no-scrolling");
	} else {
		body.classList.remove("no-scrolling");
		html.classList.remove("no-scrolling");
	}
};
export const __getSimplEmiPrice = (productPrice, totalInstallments) => {
	let amountInPaise = productPrice * 100;
	let div = Math.floor(amountInPaise / totalInstallments);
	let rem = amountInPaise - (div * 3);
	let part = div + rem;
	let amountInRs = parseFloat(part / 100);
	return amountInRs;
};